const s = {
  name: "Laptop",
  dimensions: { width: 40, height: 30 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 30" style="enable-background:new 0 0 40 30;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M18.8,5c0-0.7,0.6-1.3,1.2-1.3s1.2,0.6,1.2,1.3S20.7,6.3,20,6.3S18.8,5.7,18.8,5z"/>
		<path class="st0" d="M6,0C4.3,0,3,1.3,3,3v20c0,1.7,1.3,3,3,3h28c1.7,0,3-1.3,3-3V3c0-1.7-1.3-3-3-3H6z M5,3c0-0.5,0.5-1,1-1h28
			c0.5,0,1,0.5,1,1v20c0,0.5-0.5,1-1,1H6c-0.5,0-1-0.5-1-1V3z"/>
		<path class="st0" d="M40,28v2H0v-2H40z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Laptop
};
